import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { RouteConstants } from "@core/constants/route.constants";
import { environment } from "environments/environment";

@Injectable({ providedIn: 'root' })
export class DisableProductionAccessGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    if (!environment.enableDownloadSection) {
      this.router.navigate([RouteConstants.PRODUCT_MODULE.CATALOG]);
      return false;
    }

    return true;
  }
}
